import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ChevronLast: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm7 18 6-6-6-6' }],
    ['path', { d: 'M17 6v12' }],
  ],
];

export default ChevronLast;
